import { render, staticRenderFns } from "./PaymentMethodEdit.vue?vue&type=template&id=25106d14"
import script from "../../controllers/payment_method/payment-method-edit.js?vue&type=script&lang=js&external"
export * from "../../controllers/payment_method/payment-method-edit.js?vue&type=script&lang=js&external"
import style0 from "./PaymentMethodEdit.vue?vue&type=style&index=0&id=25106d14&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports